import { frontendURL } from '../../../../helper/URLHelper';
import { LABEL_PERMISSIONS } from 'dashboard/constants/permissions';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          meta: {
            permissions: LABEL_PERMISSIONS,
          },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'labels_list',
          meta: {
            permissions: LABEL_PERMISSIONS,
          },
          component: Index,
        },
      ],
    },
  ],
};
